import { render, staticRenderFns } from "./ExternalComponent.vue?vue&type=template&id=0532be1a&"
import script from "./ExternalComponent.vue?vue&type=script&lang=js&"
export * from "./ExternalComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExternalComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports